import { Flex, Typography } from 'antd'
import { ReactComponent as LogoImage } from '../assets/logo.svg'
import { scalingConfig } from '../utils/scaling'

interface LogoProps {
  textColor?: string
  logoColor?: string
}

export default function Logo({ logoColor = '#ffa902', textColor = 'white' }: LogoProps) {
  return (
    <Flex gap={6} align="center" style={{ marginBottom: '0.5rem' }}>
      <LogoImage width="2.5rem" height="2.5rem" style={{ color: logoColor }} />
      <Flex vertical justify="center" align="center">
        <span style={{ color: textColor }}>{scalingConfig.APP_NAME}</span>
        {scalingConfig.SUB_NAME && <span style={{ color: textColor }}>{scalingConfig.SUB_NAME}</span>}
      </Flex>
    </Flex>
  )
}
